// DST(夏令时开始): 向前调 1 小时 例 2025-03-30没有1点 00:59 -> 02:00
// "2025-03-30": {
//   time: "02:00",
//   num: 2,
//   type: "DST",
// },
// ST(夏令时结束): 向后调 1 小时 例 2025-10-26重复1点 01:59 -> 01:00
// "2025-10-26": {
//   time: "01:00",
//   num: 1,
//   type: "ST",
// }
function dateList(DSTTime, STTime) {
  let strDSTTime, strSTTime;
  if (DSTTime < 10) {
    strDSTTime = "0" + DSTTime + ":00";
  } else {
    strDSTTime = DSTTime + ":00";
  }
  if (STTime < 10) {
    strSTTime = "0" + STTime + ":00";
  } else {
    strSTTime = STTime + ":00";
  }
  return {
    "2025-03-30": {
      time: strDSTTime,
      num: DSTTime,
      type: "DST",
    },
    "2025-10-26": {
      time: strSTTime,
      num: STTime,
      type: "ST",
    },
    "2026-03-29": {
      time: strDSTTime,
      num: DSTTime,
      type: "DST",
    },
    "2026-10-25": {
      time: strSTTime,
      num: STTime,
      type: "ST",
    },
    "2027-03-28": {
      time: strDSTTime,
      num: DSTTime,
      type: "DST",
    },
    "2027-10-31": {
      time: strSTTime,
      num: STTime,
      type: "ST",
    },
    "2028-03-26": {
      time: strDSTTime,
      num: DSTTime,
      type: "DST",
    },
    "2028-10-29": {
      time: strSTTime,
      num: STTime,
      type: "ST",
    },
    "2029-03-25": {
      time: strDSTTime,
      num: DSTTime,
      type: "DST",
    },
    "2029-10-28": {
      time: strSTTime,
      num: STTime,
      type: "ST",
    },
    "2030-03-31": {
      time: strDSTTime,
      num: DSTTime,
      type: "DST",
    },
    "2030-10-27": {
      time: strSTTime,
      num: STTime,
      type: "ST",
    },
    "2031-03-30": {
      time: strDSTTime,
      num: DSTTime,
      type: "DST",
    },
    "2031-10-26": {
      time: strSTTime,
      num: STTime,
      type: "ST",
    },
    "2032-03-28": {
      time: strDSTTime,
      num: DSTTime,
      type: "DST",
    },
    "2032-10-31": {
      time: strSTTime,
      num: STTime,
      type: "ST",
    },
    "2033-03-27": {
      time: strDSTTime,
      num: DSTTime,
      type: "DST",
    },
    "2033-10-30": {
      time: strSTTime,
      num: STTime,
      type: "ST",
    },
    "2034-03-26": {
      time: strDSTTime,
      num: DSTTime,
      type: "DST",
    },
    "2034-10-29": {
      time: strSTTime,
      num: STTime,
      type: "ST",
    }
  }
}
export default {
  // 伦敦
  "Europe/London": dateList(2, 1),
  // 斯德哥尔摩
  "Europe/Stockholm": dateList(3, 2),
  // 柏林
  "Europe/Berlin": dateList(3, 2),
  // 布达佩斯
  "Europe/Budapest": dateList(3, 2),
  // 马德里
  "Europe/Madrid": dateList(3, 2),
  // 雅典
  "Europe/Athens": dateList(4, 3),
  // 基辅
  "Europe/Kiev": dateList(4, 3),
  // 罗马
  "Europe/Rome": dateList(3, 2),
  // 巴黎
  "Europe/Paris": dateList(3, 2),
  // 都柏林
  "Europe/Dublin": dateList(2, 1),
};
